import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  PROFILE_SETTINGS_PERMISSIONS,
} from '@modules/profile-settings/constants';
import { useToastStore } from '@modules/toast/store';

import type {
  IProfileSettingsConfirmationEmailSchema,
} from '../types';
import {
  PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_MUTATION_KEY,
  PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_URL,
} from '../constants';

export default function useProfileSettingsConfirmEmailMutation(): IContextMutationResult<
  void,
  Error,
  IProfileSettingsConfirmationEmailSchema
> {
  const { fetchGet } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IProfileSettingsConfirmationEmailSchema>({
    mutationKey: [PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_MUTATION_KEY],
    mutationFn: (queryParams) => fetchGet<void>(
      PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_URL,
      {
        permission: PROFILE_SETTINGS_PERMISSIONS.EDIT,
        queryParams,
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
